module.exports = __webpack_public_path__ + "img/logo.d6b926d2.svg";